module.exports = __webpack_public_path__ + "img/TPV-L1-4-Pagina2C .a06d583b.png";